/**
 * Some Code are commented for the phase2, where extra filter will be added.
 */
import React, { useEffect, useState } from "react";
import CustomDropdown from "../../../components/reusable-ui/custom-dropdown";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import AddIcon from '@mui/icons-material/Add';
import CachedIcon from '@mui/icons-material/Cached';
import { convertArrayToObject } from "../../../helpers/catalog-helper";
import { isUserCashier } from "../../../helpers/isUserCashier";
import { getActiveBranches } from "../../../helpers/common-helper";
// import BranchFilterComponent from "../../../components/reusable-ui/branch-filter";
// import DateRangePicker from "../../../components/reusable-ui/date-range-picker";
// import { DATE_TIME_FORMATS } from "../../../data/constants";
// import moment, { Moment } from "moment";
// import { convertMomentToString } from "../../../helpers/moment-helper";
// import TuneIcon from '@mui/icons-material/Tune';

interface Props {
  updateSelectedBranch: any;
  showAddTransactionView: (...args: any[]) => void;
  refershData: (...args: any[]) => void;
}
const TableActionBar = (props: Props) => {
  const {
    updateSelectedBranch,
    showAddTransactionView,
    refershData
  } = props;

  // const [reasonValue, setReasonValue] = useState<string>("");
  const [selectedBranch, setSelectedBranch] = useState<string>("");
  const userData = useSelector((state: any) => state.businessReducer.userData);
  const allowedBusinessBranchesDataMap = convertArrayToObject(
    userData.permittedBranches,
    "branchId"
  );
  const currentBusinessId = useSelector((state: any) => state.businessReducer?.businessData?.branchId)

  // const reasonsDataMap = {
  //   "1": {"name": "Reason1", "reasonId": "1"},
  //   "2": {"name": "Reason2", "reasonId": "2"},
  //   "3": {"name": "Reason3", "reasonId": "3"}
  // };

  // const { permittedBranchesData } = useSelector(
  //   (state: RootState) => ({
  //     permittedBranchesData: state.businessReducer.userData.permittedBranches,
  //   })
  // );

  useEffect(() => {
    if (
      allowedBusinessBranchesDataMap &&
      Object.keys(allowedBusinessBranchesDataMap).length &&
      !selectedBranch
    ) {
      let firstObj: any = allowedBusinessBranchesDataMap[currentBusinessId];
      if (firstObj.branchId) {
        setSelectedBranch(firstObj.branchId);
        updateSelectedBranch(firstObj);
      }
    }
  }, [allowedBusinessBranchesDataMap]);

  // const dateFormat = DATE_TIME_FORMATS.dayMonthYear,
  //   // dispatch = useDispatch(),
  //   defaultDateRange = {
  //     startDate: moment(moment().subtract(6, "d")),
  //     endDate: moment(),
  //   },
  //   [payload, setPayload] = useState<any>({
  //     branchIds: [],
  //     dateRange: {
  //       startDate: convertMomentToString(
  //         defaultDateRange.startDate,
  //         DATE_TIME_FORMATS.yearMonthDay
  //       ),
  //       endDate: convertMomentToString(
  //         defaultDateRange.endDate,
  //         DATE_TIME_FORMATS.yearMonthDay
  //       ),
  //     },
  //   });

    const DROPDOWN_CONFIGS = {
      branchId: {
        optionsMap: getActiveBranches(allowedBusinessBranchesDataMap),
        placeholder: "Select Branch",
        uniqueKey: "branchId",
        dropdownHeading: "Branches",
        searchPlaceholder: "Search a branch",
        parentClass: "max-w-[200px] sm:w-full",
        key: "branchId",
        disable: isUserCashier(), 
        getListItemText: (data: any) => data?.branchName,
      },
    };

    /**
   * The dates more than 3 years will always be disabled
   * @param current
   */
  // function disabledDate(current: any) {
  //   return (
  //     current &&
  //     (current >= moment().endOf("day") || moment().diff(current, "days") > 89)
  //   );
  // }

  // function onDateRangeSubmission(data: { startDate: Moment; endDate: Moment }) {
  //   let startDateStr = convertMomentToString(
  //       data.startDate,
  //       DATE_TIME_FORMATS.yearMonthDay
  //     ),
  //     endDateStr = convertMomentToString(
  //       data.endDate,
  //       DATE_TIME_FORMATS.yearMonthDay
  //     );
  //   setPayload({
  //     ...payload,
  //     dateRange: {
  //       startDate: startDateStr,
  //       endDate: endDateStr,
  //     },
  //   });
  //   dispatch(
  //     saveDashboardFilterState({
  //       key: "dateRange",
  //       value: {
  //         startDate: startDateStr,
  //         endDate: endDateStr,
  //       },
  //     })
  //   );
  // }

  // function renderBranchFilterDropdown(config: {
  //   parentClass?: string;
  //   customClass?: string;
  // }) {
  //   const { parentClass = "", customClass = "" } = config;
  //   return (
  //     <BranchFilterComponent
  //       onApplyCtaClick={(branchIds: any) => setSelectedBranches(branchIds)}
  //       selectAllBranches={true}
  //       parentClass={`ml-0 ${parentClass || ""}`}
  //       customClass={customClass}
  //       branchDataList={permittedBranchesData}
  //     ></BranchFilterComponent>
  //   );
  // }

  const handleBranchSelection = (value: any, fieldToUpdate: string) => {
    console.log("handleBranchSelection: ", value, fieldToUpdate);
    setSelectedBranch(value);
    updateSelectedBranch(allowedBusinessBranchesDataMap[value]);
  };

  function renderCustomDropDown(dropdownConfig: {
    optionsMap: any;
    placeholder?: string;
    getListItemText?: any;
    parentClass?: string;
    dropdownHeading?: string;
    searchPlaceholder?: string;
    uniqueKey: any;
    key: string;
    disable?: boolean
  }): any {
    return (
      <CustomDropdown
        optionsMap={dropdownConfig.optionsMap}
        isMultiSelect={false}
        placeholder={dropdownConfig.placeholder}
        getListItemText={dropdownConfig.getListItemText}
        parentClass={dropdownConfig.parentClass}
        dropdownHeading={dropdownConfig.dropdownHeading}
        searchPlaceholder={dropdownConfig.searchPlaceholder}
        onSubmit={(value: any) =>
          handleBranchSelection(value[0], dropdownConfig.key)
        }
        preSelectedValues={selectedBranch}
        uniqueKey={dropdownConfig.uniqueKey}
        showErrorBox={false}
        isDisabled = {dropdownConfig.disable}
      ></CustomDropdown>
    );
  }

  return (
    <div className="table-action-bar-container flex justify-between items-center px-24 py-16 sm:flex-col sm:px-16">
      <div className="text-18 text-black font-semibold sm:hidden">
        Petty Cash Management
      </div>
      <div className="hidden justify-between sm:flex w-full items-center">
        <div className="text-16 text-black font-semibold">
          Petty Cash Management
        </div>
        <div className="flex gap-15">
          <AddIcon sx={{color: "#397EF5", fontSize: "30px"}} onClick={showAddTransactionView}/>
          <CachedIcon sx={{color: "#397EF5", fontSize: "30px"}} onClick={refershData} />
        </div>
      </div>
      <div className="filters-cnt flex gap-15 items-center justify-end w-3/4 sm:w-full sm:justify-between sm:mt-10">
        <div className="branch-selection sm:w-8/12 w-[200px]">
          {renderCustomDropDown(DROPDOWN_CONFIGS.branchId)}
        </div>
        {/* <div className="">
          {renderBranchFilterDropdown({
            customClass: "!pl-[24px] !h-[40px]",
            parentClass: "!h-[40px]",
          })}
        </div> */}
        {/* <DateRangePicker
          dateFormat={dateFormat}
          disabledDate={disabledDate}
          timeDifference={90}
          errorMessage={`You can select date range max upto 90 days!`}
          onSubmit={onDateRangeSubmission}
          defaultDateRange={[
            defaultDateRange.startDate,
            defaultDateRange.endDate,
          ]}
        ></DateRangePicker> */}
        {/* <div className="hidden mobile-filters-cnt border border-[#387EF6] px-8 py-8 rounded-[6px] sm:flex items-center gap-10">
          <span className="text-16 text-[#397EF5]">Filters</span>
          <TuneIcon sx={{color: "#397EF5"}} />
        </div> */}
        <div className="add-transaction-btn border border-[#397EF5] p-6 rounded-[6px] hover:bg-[#E4E5EC] cursor-pointer sm:hidden">
          <AddIcon sx={{color: "#397EF5", fontSize: "30px"}} onClick={showAddTransactionView}/>
        </div>
        <div className="refresh-btn border border-[#397EF5] p-6 rounded-[6px] hover:bg-[#E4E5EC] cursor-pointer sm:hidden">
          <CachedIcon sx={{color: "#397EF5", fontSize: "30px"}} onClick={refershData} />
        </div>
      </div>
    </div>
  )
}

export default TableActionBar;